import React, { useRef } from 'react'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { useUser } from '../../context/useUser';

function Testimonials() {
    const { country } = useUser()
    const carouselRef = useRef(null);
    const responsive = {
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
        tablet: { breakpoint: { max: 1024, min: 768 }, items: 2 },
        mobile: { breakpoint: { max: 768, min: 0 }, items: 1 },
    };
    const testimonials = [
        {
            id: 1,
            name: "Ahmed Raza",
            location: "Lahore, Pakistan",
            review:
                "Alif Cattle & Goat Farm made my Qurbani effortless! The meat was fresh, hygienic, and delivered right on time. Truly reliable and stress-free service!",
            image: "https://randomuser.me/api/portraits/men/1.jpg",
        },
        {
            id: 2,
            name: "Fatima Khan",
            location: "Karachi, Pakistan",
            review:
                "I was amazed by the quality of the beef and mutton! Tender, flavorful, and perfectly cut. Highly recommended for anyone looking for fresh, Halal meat in Pakistan!",
            image: "https://randomuser.me/api/portraits/women/1.jpg",
        },
        {
            id: 3,
            name: "Bilal Siddique",
            location: "Islamabad, Pakistan",
            review:
                "Their service exceeded my expectations! Clean packaging, premium quality, and prompt delivery. Alif has become my go-to for fresh meat!",
            image: "https://randomuser.me/api/portraits/men/2.jpg",
        },
    ];

    const handlePrev = () => {
        if (carouselRef.current) {
            carouselRef.current.previous();
        }
    };

    const handleNext = () => {
        if (carouselRef.current) {
            carouselRef.current.next();
        }
    };
    return (
        <div className={`${country === "PK" ? "bg-[#f7e6e4]" : "bg-[#fafcf0]"} mt-8 h-full px-6`}>
            <div className="max-w-[1300px] md:px-8 py-20 mx-auto relative">
                <div className="flex justify-between items-center mb-8">
                    <h1 className="font-[600] text-2xl text-[#1a1a1a] md:text-3xl">
                        Our Satisfied Customers
                    </h1>
                    {/* Custom Navigation Buttons */}
                    <div className="flex gap-3">
                        <button
                            className="p-2 bg-white rounded-full shadow-md hover:bg-gray-200"
                            onClick={handlePrev}
                        >
                            <ArrowLeft size={22} className="text-gray-700" />
                        </button>
                        <button
                            className={`p-2 ${country === "PK" ? "bg-[#912c24]" : "bg-[#65754d]"} rounded-full shadow-md hover:bg-[#6b2c2c] text-white`}
                            onClick={handleNext}
                        >
                            <ArrowRight size={22} />
                        </button>
                    </div>
                </div>
                <div className="relative">
                    <Carousel
                        ref={carouselRef}
                        responsive={responsive}
                        infinite={true}
                        autoPlay={true}
                        autoPlaySpeed={3000}
                        showDots={false}
                        arrows={false}
                        className="flex gap-3"
                    >
                        {testimonials.map((testimonial) => (
                            <div
                                key={testimonial.id}
                                className="bg-white p-6 relative rounded-lg shadow-md mx-3"
                            >
                                <p className={`text-[80px] absolute top-0 left-4 ${country === "PK" ? "text-[#f7e6e4]" : "text-[#65754d]"}`}>❝</p>
                                <p className="text-gray-700 text-[15px] mt-16 mb-10">{testimonial.review}</p>
                                <div className="flex justify-between items-center">
                                    <div className="flex items-center">
                                        <img
                                            src={testimonial.image}
                                            alt={testimonial.name}
                                            className="w-12 h-12 rounded-full border-2 border-gray-300 mr-3"
                                        />
                                        <div>
                                            <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                                            <p className="text-gray-500 text-sm">{testimonial.location}</p>
                                        </div>
                                    </div>
                                    <div className="flex">
                                        {Array(5)
                                            .fill(0)
                                            .map((_, index) => (
                                                <span key={index} className="text-yellow-500 text-lg">★</span>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </div>
        </div>
    )
}

export default Testimonials